import React from "react";
import { EmptyJobsPage, noResultIcon, ReloadIcon } from "../../../assets/images";
import { CHECKLIST_HEADER } from "../../../constant/tableHeadersConstants/jobProgressHeaderConst";
import { SearchIcon } from "../../Icon";
import {
  AllOpenJobChecklistDataType,
  JobSingleType,
} from "../../../commonTypes/jobsType";
import CheckListModalData from "./CheckListModalData";
import { EmptyListPage, TableHeader, TableLoader } from "../../commons";

type AppProps = {
  data: AllOpenJobChecklistDataType[] | [];
  history?: any;
  jobSingleData: JobSingleType | null | number;
  handleSearch?: (e: any) => void;
  fetchChecklistData?: (searchData?: string) => void;
  dispatchResetAllOpenJobChecklistSingleData: () => void;
  isAllOpenJobCheckListDetailPresent?: boolean;
  searchSize?: number
  emptyImageSize?: string;
  actionRemove?: boolean;
  checklistSearchData: string;
  jobFetching?: boolean
};
const CheckListModalViewcontainer = ({
  data,
  history,
  jobSingleData,
  fetchChecklistData,
  handleSearch,
  dispatchResetAllOpenJobChecklistSingleData,
  isAllOpenJobCheckListDetailPresent,
  searchSize,
  emptyImageSize,
  actionRemove,
  checklistSearchData,
  jobFetching
}: AppProps) => {
  let checklistHeader = CHECKLIST_HEADER
  if (actionRemove) {
    checklistHeader = CHECKLIST_HEADER.filter((el) => el?.label != "Action")
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-beetween">
        <div
          className={`col-md-${searchSize ? searchSize : "9"} position-relative mt-4 mb-4 ml-1`}
          style={{ marginRight: "-29px", marginLeft: "-10px" }}
        >
          <span style={{ position: "absolute", top: "8px", left: "25px" }}>
            <SearchIcon />
          </span>
          <input
            className="form-control"
            type="text"
            placeholder="Search..."
            onChange={(e) => handleSearch && handleSearch(e)}
            style={{ paddingLeft: "35px" }}
            value={checklistSearchData}
          />
        </div>
        {/* commented for future use */}
        {/* <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={renderTooltip("", "Refresh")}
                        >
                          <div
                            className="pointer mr-3"
                            onClick={() => fetchChecklistData()}
                          >
                            <img src={ReloadIcon} alt="" />
                          </div>
                        </OverlayTrigger> */}
      </div>
      {jobFetching ? (
        <TableLoader Rows={10} ColumnPerRow={7} />
      ) : data?.length ? (
        <table className="thead-light table">
          <thead className="sticky-table-header">
            <TableHeader tableHeader={checklistHeader} />
          </thead>
          <tbody>
            <CheckListModalData
              history={history}
              data={data}
              dispatchResetAllOpenJobChecklistSingleData={
                dispatchResetAllOpenJobChecklistSingleData
              }
              jobSingleData={jobSingleData}
              tableHeader={checklistHeader}
              isAllOpenJobCheckListDetailPresent={
                isAllOpenJobCheckListDetailPresent
              }
            />
          </tbody>
        </table>
      ) : (
        <div className="mt-5 p-4">
          <EmptyListPage
            title="No Data Found!"
            image={noResultIcon}
            imageWidth={emptyImageSize ? emptyImageSize : "30%"}
            showLinkButton={false}
            showAddButton={false}
          />
        </div>
      )}
    </div>
  );
};

export default CheckListModalViewcontainer;
